var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { handleErrorSnackbar, showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { useUserState } from '@juvare/contact-management/ui/hooks';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { CircularProgress, IconButton, Tooltip } from '@mui/material';
import React from 'react';
import { useDocumentLibraryStorage, useDocumentLibraryTranslations } from '../hooks';
import { truncateText } from '../utils';
export const WatchButton = ({ fileId, watchersList, fileName, onReload }) => {
    const { t } = useDocumentLibraryTranslations();
    const userState = useUserState();
    const [watching, setWatching] = React.useState(watchersList.some((id) => id === (userState === null || userState === void 0 ? void 0 : userState.id)));
    const [isLoading, setIsLoading] = React.useState(false);
    const storage = useDocumentLibraryStorage();
    const toggleWatch = React.useCallback((event) => __awaiter(void 0, void 0, void 0, function* () {
        event.stopPropagation();
        setIsLoading(true);
        try {
            if (watching) {
                yield storage.unwatchFile({ fileId });
                showAlertSnackbar({
                    message: t('documentPanel.stoppedWatchingMessage', { fileName: truncateText(fileName, 20) }),
                    type: 'success',
                    autoHideDuration: 5000,
                });
            }
            else {
                yield storage.watchFile({ fileId });
                showAlertSnackbar({
                    message: t('documentPanel.watchingMessage', { fileName: truncateText(fileName, 20) }),
                    type: 'success',
                    autoHideDuration: 5000,
                });
            }
            setWatching(!watching);
        }
        catch (error) {
            handleErrorSnackbar(error);
        }
        finally {
            setIsLoading(false);
            onReload();
        }
    }), [fileId, watching, storage, t, fileName, onReload]);
    const renderIcon = () => {
        if (isLoading) {
            return React.createElement(CircularProgress, { size: 24 });
        }
        if (watching) {
            return React.createElement(VisibilityIcon, { color: 'primary' });
        }
        return React.createElement(VisibilityOutlinedIcon, null);
    };
    return (React.createElement(Tooltip, { title: watching ? t('documentPanel.watching') : t('documentPanel.notWatching') },
        React.createElement(IconButton, { "aria-label": watching ? t('documentPanel.watch') : t('documentPanel.unwatch'), onClick: toggleWatch, disabled: isLoading }, renderIcon())));
};
